import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { connect } from "react-redux";
import { setCustomerName } from "../../reducers/actions";
import { utcToLocal } from "../../utils/dateConvert";
import { Link } from "react-router-dom";

class IbuttonTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortString: "name",
      sortDirection: "asc",
    };
    this.sortStringName = "name";
    this.sortDirection = "asc";
  }
  componentDidMount() { }

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };
  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.props.sortFunction(name, order);
  };

  render() {
    const { customers } = this.props;

    return (
      <Table striped>
        <thead>
          <tr>
            <th>
              Customer{" "}
              {this.state.sortString == "customer" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("customer");
                  }}
                />
              )}
            </th>
            <th>Serial No </th>
            <th>
              Name{" "}
              {this.state.sortString == "name" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("name");
                  }}
                />
              )}
            </th>
            <th>
              State{" "}
              {this.state.sortString == "state" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("state");
                  }}
                />
              )}{" "}
            </th>
            <th>
              Last event{" "}
              {this.state.sortString == "lastevent" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("lastevent");
                  }}
                />
              )}{" "}
            </th>
            <th>Asset </th>
            <th>
              Last connected{" "}
              {this.state.sortString == "lastconnected" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("lastconnected");
                  }}
                />
              )}{" "}
            </th>
            <th>
              Last disconnected{" "}
              {this.state.sortString == "lastdisconnected" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("lastdisconnected");
                  }}
                />
              )}{" "}
            </th>
            <th>Status </th>

            <th></th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer, index) => {
            return (
              <tr>
                <td>{customer.customerName}</td>
                <td>{customer.serialNo}</td>
                <td>{customer.name}</td>
                <td>
                  <span
                    style={
                      customer.state == "Disconnected"
                        ? { color: "red" }
                        : { color: "green" }
                    }
                  >
                    {customer.state}
                  </span>
                </td>
                <td>{utcToLocal(customer.lastevent)}</td>
                <td>{customer.assetName}</td>
                <td>{utcToLocal(customer.lastConnect)}</td>
                <td>{utcToLocal(customer.lastDisconnect)}</td>
                <td>{customer.status}</td>
                <td>
                  <Link to={`/editIbutton/${customer.id}`}>Edit</Link> |{" "}
                  <Link to={`/ibuttonDetails/${customer.id}`}>Details</Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}
const mapStateToProps = (state) => ({
  customerName: state.customerName,
});
const mapDispatchToProps = {
  setCustomerNameAction: setCustomerName,
};

export default connect(mapStateToProps, mapDispatchToProps)(IbuttonTable);
